(function () {
  'use strict';

  const SKU_PREFIX_RE = /^\s*\[([^\]]+)\]/;

  function getSlideSku(slideEl) {
    const img = slideEl.querySelector('img[alt]');
    if (!img) return null;
    const m = img.alt.match(SKU_PREFIX_RE);
    return m ? m[1].trim().toUpperCase() : null;
  }

  function filterGallery(activeSku) {
    if (!activeSku) return;
    const galleries = document.querySelectorAll('media-gallery');
    galleries.forEach((gallery) => {
      const slides = gallery.querySelectorAll('.media-viewer__item');
      const thumbs = gallery.querySelectorAll('.media-thumbs__item');

      // Determine if this gallery has any [SKU]-prefixed slides at all.
      // If none, this is a legacy product — leave everything alone.
      let hasPrefixed = false;
      for (const s of slides) {
        if (getSlideSku(s) !== null) { hasPrefixed = true; break; }
      }
      if (!hasPrefixed) return;

      // First pass: count how many slides match the active SKU. If zero,
      // we'd blank the gallery — fall back to no-prefix slides only, or as
      // a last resort show every slide (better cluttered than empty).
      let activeMatchCount = 0;
      let nullSkuCount = 0;
      for (const s of slides) {
        const sku = getSlideSku(s);
        if (sku === activeSku) activeMatchCount++;
        else if (sku === null) nullSkuCount++;
      }
      const fallbackShowAll = activeMatchCount === 0 && nullSkuCount === 0;

      const visibleMediaIds = new Set();
      slides.forEach((slide) => {
        const slideSku = getSlideSku(slide);
        // null = no prefix → keep visible (shared/hero images)
        // matching SKU → keep visible
        // other SKU → hide
        // fallback: if active SKU has zero matches AND no shared images exist,
        // show everything rather than render an empty gallery
        const shouldShow = fallbackShowAll || slideSku === null || slideSku === activeSku;
        slide.style.display = shouldShow ? '' : 'none';
        slide.toggleAttribute('hidden', !shouldShow);
        if (shouldShow) {
          const mid = slide.getAttribute('data-media-id');
          if (mid) visibleMediaIds.add(mid);
        }
      });

      thumbs.forEach((thumb) => {
        const mid = thumb.getAttribute('data-media-id');
        const shouldShow = visibleMediaIds.has(mid);
        thumb.style.display = shouldShow ? '' : 'none';
        thumb.toggleAttribute('hidden', !shouldShow);
      });

      // Tell the gallery to refresh its visible-items state
      if (typeof gallery.setVisibleItems === 'function') {
        try { gallery.setVisibleItems(); } catch (e) { /* swallow */ }
      }

      // If the previously-active slide is now hidden, scroll to first visible
      const currentActive = gallery.querySelector('.media-viewer__item.is-current-variant');
      if (currentActive && currentActive.style.display === 'none') {
        const firstVisible = Array.from(slides).find((s) => s.style.display !== 'none');
        if (firstVisible) {
          // Best-effort: dispatch click on its thumbnail or scroll into view
          const firstMid = firstVisible.getAttribute('data-media-id');
          const firstThumb = gallery.querySelector(`.media-thumbs__item[data-media-id="${firstMid}"] button, .media-thumbs__item[data-media-id="${firstMid}"]`);
          if (firstThumb && typeof firstThumb.click === 'function') firstThumb.click();
          else firstVisible.scrollIntoView({ behavior: 'instant', block: 'nearest', inline: 'start' });
        }
      }
    });
  }

  function getInitialSku() {
    // 1. variant-picker JSON: shape on this theme is { product: { variants: [...] }, formatted: {...} }
    //    Combined with ?variant=<id> URL param, this is the most reliable source.
    const picker = document.querySelector('variant-picker script[type="application/json"]');
    if (picker) {
      try {
        const data = JSON.parse(picker.textContent);
        const variants = (data && data.product && Array.isArray(data.product.variants)) ? data.product.variants
          : (data && Array.isArray(data.variants)) ? data.variants
          : null;
        if (variants && variants.length) {
          const urlVariantId = new URLSearchParams(window.location.search).get('variant');
          if (urlVariantId) {
            const matched = variants.find((v) => String(v.id) === String(urlVariantId));
            if (matched && matched.sku) return String(matched.sku).toUpperCase();
          }
          const firstAvailable = variants.find((v) => v.available !== false && v.sku);
          if (firstAvailable) return String(firstAvailable.sku).toUpperCase();
          if (variants[0] && variants[0].sku) return String(variants[0].sku).toUpperCase();
        }
      } catch (e) { /* swallow */ }
    }
    // 2. Breadcrumb SKU element (this theme's actual rendering)
    const breadcrumbSku = document.querySelector('.js-breadcrumb-sku');
    if (breadcrumbSku && breadcrumbSku.textContent && breadcrumbSku.textContent.trim()) {
      return breadcrumbSku.textContent.trim().toUpperCase();
    }
    // 3. Legacy fallback for themes that render .product-sku__value
    const skuEl = document.querySelector('.product-sku__value');
    if (skuEl && skuEl.textContent && skuEl.textContent.trim()) {
      return skuEl.textContent.trim().toUpperCase();
    }
    return null;
  }

  function init() {
    const initialSku = getInitialSku();
    if (initialSku) filterGallery(initialSku);

    document.addEventListener('on:variant:change', function (e) {
      if (e && e.detail && e.detail.variant && e.detail.variant.sku) {
        filterGallery(String(e.detail.variant.sku).toUpperCase());
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    // Allow `<media-gallery>` to define + run its own init first (it's also DOMContentLoaded-bound)
    setTimeout(init, 0);
  }
})();
